const media = {
    tablet: '768px',
    desktop: '1125px',
    mini: '320px',
};

export default media;
